module.exports = ({"button":"Wo kann ich es sehen?"});